export const ENABLE_PERFORMANCE_STATS =
  process.env.REACT_APP_ENABLE_3D_PERFORMANCE_STATS

export const PROPERTY_LABEL_PREFIX = 'Level'

export const SHOW_HIGHLIGHTED_LEVEL_INFO = false

export const NO_FOCUS_TARGETS: string[] = []
